"use strict";

var _classCallCheck = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailService = exports.DEFAULT_OPTIONS = void 0;
/** The default options for the email service. */

exports.DEFAULT_OPTIONS = {};
/**
 * Sends emails on behalf of the system.
 */

var EmailService = function EmailService(options) {
  _classCallCheck(this, EmailService);

  this.options = Object.assign(Object.assign({}, exports.DEFAULT_OPTIONS), options);
};

exports.EmailService = EmailService;